import { render, staticRenderFns } from "./small-business-administration.vue?vue&type=template&id=331d442c&scoped=true"
import script from "./small-business-administration.vue?vue&type=script&lang=js"
export * from "./small-business-administration.vue?vue&type=script&lang=js"
import style0 from "./small-business-administration.vue?vue&type=style&index=0&id=331d442c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d442c",
  null
  
)

export default component.exports